import { useState } from "react";
import { useCreateTransaction } from "../../features/transaction";
import { useGetProduct } from "../../features/product";
import { useNavigate } from "react-router-dom";
import { useGetCategory } from "../../features/category";

const AddOrderForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    categoryId: "",
    productCode: "",
    price: 0,
    discount: 0,
    phone: "",
    customerPhone: "",
    customerName: "",
    customerEmail: "",
    paymentType: "",
  });

  const { category } = useGetCategory();
  const { product: defaultProduct } = useGetProduct();
  const { product: filteredProduct } = useGetProduct(formData.categoryId);

  const product = formData.categoryId ? filteredProduct : defaultProduct;

  const { transaction: Create } = useCreateTransaction();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSelectCategory = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedCategoryId = e.target.value;
    setFormData({
      ...formData,
      categoryId: selectedCategoryId,
      productCode: "",
      price: 0,
      paymentType: "",
    });
  };

  const handleSelectProduct = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedProductCode = e.target.value;
    const selectedProduct = product?.find(
      (prod) => prod.code === selectedProductCode
    );
    if (selectedProduct) {
      setFormData({
        ...formData,
        productCode: selectedProduct.code,
        price: selectedProduct.price,
        paymentType: selectedProduct.paymentType,
      });
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const transformPhone = (phone: string) => {
      if (phone.startsWith("0")) return "62" + phone.slice(1);
      return phone;
    };

    const transformedData = {
      productCode: formData.productCode,
      price: formData.price || 0,
      discount: formData.discount || 0,
      phone: transformPhone(formData.phone),
      customerPhone: transformPhone(formData.customerPhone),
      customerName: formData.customerName,
      customerEmail: formData.customerEmail,
      paymentType: formData.paymentType,
    };
    Create(transformedData, {
      onSuccess: (data) => {
        if (formData.paymentType === "DIRECT") {
          navigate(`/add-order/verify-otp/${data.data.id}`);
        }
      },
    });
    console.log("Order Data Submitted:", transformedData);
  };

  const formatNumber = (value: number | string) => {
    if (!value) return "";
    return Number(value.toString().replace(/\D/g, "")).toLocaleString("id-ID");
  };

  const parseNumber = (value: string) => {
    return Number(value.replace(/\./g, ""));
  };

  const handleDiscountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value;
    const numberValue = parseNumber(rawValue);
    setFormData({
      ...formData,
      discount: numberValue,
    });
  };

  return (
    <div className="min-h-screen">
      <div className="bg-white rounded-xl w-full max-w-2xl p-4 lg:p-5 border-gray-100">
        <h1 className="text-lg lg:text-xl font-semibold text-center text-black mb-8">
          Create New Transaction
        </h1>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Kategori Produk
            </label>
            <select
              id="categoryId"
              name="categoryId"
              value={formData.categoryId}
              onChange={handleSelectCategory}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm"
            >
              <option value="">Pilih Kategori</option>
              {category?.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {cat.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Produk
            </label>
            <select
              id="productCode"
              name="productCode"
              value={formData.productCode}
              onChange={handleSelectProduct}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm"
            >
              <option value="">Pilih Produk</option>
              {product?.map((prod) => (
                <option key={prod.code} value={prod.code}>
                  {prod.name} — Rp {prod.price.toLocaleString("id-ID")}
                </option>
              ))}
            </select>

            <p className="text-xs text-gray-500 mt-2 italic bg-gray-50 p-2 rounded">
              {formData.productCode
                ? product?.find((p) => p.code === formData.productCode)
                    ?.description || "Tidak ada deskripsi produk."
                : "Pilih produk untuk melihat deskripsi."}
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Jenis Pembayaran
            </label>
            <select
              id="paymentType"
              name="paymentType"
              value={formData.paymentType}
              onChange={handleChange}
              disabled
              required
              className="w-full px-3 py-2 border border-gray-300 bg-gray-100 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm"
            >
              <option value="">Pilih Jenis Pembayaran</option>
              <option value="DIRECT">Pembayaran Langsung</option>
              <option value="INDIRECT">Payment Gateway (Xendit)</option>
            </select>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Harga
              </label>
              <input
                type="text"
                id="price"
                name="price"
                value={`Rp ${formData.price.toLocaleString("id-ID")}`}
                onChange={handleChange}
                disabled
                className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-100 text-sm"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Diskon
              </label>
              <input
                type="text"
                id="discount"
                name="discount"
                value={formatNumber(formData.discount)}
                onChange={handleDiscountChange}
                placeholder="Masukkan Diskon"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 text-sm"
              />
            </div>
          </div>

          <div className="pt-4 border-t border-gray-200">
            <h2 className="text-sm font-semibold text-gray-700 mb-3">
              Informasi Pelanggan
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Nomor HP
                </label>
                <input
                  type="number"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  placeholder="Contoh: 628xxxx"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 text-sm"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Nama Customer
                </label>
                <input
                  type="text"
                  id="customerName"
                  name="customerName"
                  value={formData.customerName}
                  onChange={handleChange}
                  required
                  placeholder="Nama Customer"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 text-sm"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Nomor HP Customer
                </label>
                <input
                  type="number"
                  id="customerPhone"
                  name="customerPhone"
                  value={formData.customerPhone}
                  onChange={handleChange}
                  required
                  placeholder="Contoh: 628xxxx"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 text-sm"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Email Customer
                </label>
                <input
                  type="email"
                  id="customerEmail"
                  name="customerEmail"
                  value={formData.customerEmail}
                  onChange={handleChange}
                  required
                  placeholder="Email Customer"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 text-sm"
                />
              </div>
            </div>
          </div>

          <div className="pt-8">
            <button
              type="submit"
              className="w-full py-3 bg-indigo-600 text-white text-sm font-semibold rounded-lg shadow hover:bg-indigo-700 transition-all duration-150 focus:ring-4 focus:ring-indigo-300"
            >
              Checkout Sekarang
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddOrderForm;
